/**
 * <<uppercase_module_name>> Module
 */
import Vue from "vue";
import Vuex from "vuex";
import api from "Api";
import router from "Router";
import app from "Main";

// import the api endpoints
import {
    getShipmentPlanners,
    getShipmentPlanner,
    printShipmentPlanner,
    createShipmentPlanners,
    updateShipmentPlanners,
    deleteShipmentPlanners,
} from "Modules/shipment_planners/config/api.shipment_planners";

const state = {
    page: {},
    form: {},
    shipment_planners: [],
    shipment_planner_options: [],
    selectedShipmentPlanner: {
        shipment_id: null,
        company_id: "",
        shipment_planner_date: "",
        reference_number: "",
        status_id: "",
        billing_address_id: "",
        shipping_address_id: "",
        comments: "",
        shipment_planner_details: [],
    },
    shipment_planners_filter: {
        search: "",
        page_size: 2,
        page_num: 1,
    },
    rules_shipment_planners: {
        shipment_id: {
            name: "shipment_id",
            rules: "trim|max_length[15]|integer|required",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        company_id: {
            name: "company_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        truck_id: {
            name: "truck_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        trailer_id: {
            name: "trailer_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        load_date: {
            name: "load_date",
            rules: "trim",
            max_len: "",
            min_len: "",
            default_value: "",
        },
        deliver_date: {
            name: "deliver_date",
            rules: "trim",
            max_len: "",
            min_len: "",
            default_value: "",
        },
        load_date_required: {
            name: "load_date",
            rules: "trim|required",
            max_len: "",
            min_len: "",
            default_value: "",
        },
        deliver_date_required: {
            name: "deliver_date",
            rules: "trim|required",
            max_len: "",
            min_len: "",
            default_value: "",
        },
        delivered_by: {
            name: "delivered_by",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        status_id: {
            name: "status_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        shipment_planner_details: {
            product_id: {
                name: "product_id",
                rules: "trim|max_length[15]|integer|required",
                max_len: "15",
                min_len: "",
                default_value: "",
            },
            quantity_ordered: {
                name: "quantity_ordered",
                rules: "trim|max_length[11]|integer|required",
                max_len: "11",
                min_len: "",
                default_value: "",
            },
            compartment: {
                name: "compartment",
                rules: "trim|max_length[11]|integer",
                max_len: "11",
                min_len: "",
                default_value: "",
            },
            document_detail_id: {
                name: "document_detail_id",
                rules: "trim|max_length[15]|integer",
                max_len: "15",
                min_len: "",
                default_value: "",
            },
            quantity_delivered: {
                name: "quantity_delivered",
                rules: "trim|max_length[11]|integer",
                max_len: "11",
                min_len: "",
                default_value: "",
            },
            ship_address1: {
                name: "ship_address1",
                rules: "trim|max_length[255]",
                max_len: "255",
                min_len: "",
                default_value: "",
            },
            ship_address2: {
                name: "ship_address2",
                rules: "trim|max_length[255]",
                max_len: "255",
                min_len: "",
                default_value: "",
            },
            ship_city: {
                name: "ship_city",
                rules: "trim|max_length[255]",
                max_len: "255",
                min_len: "",
                default_value: "",
            },
            ship_state: {
                name: "ship_state",
                rules: "trim|max_length[255]",
                max_len: "255",
                min_len: "",
                default_value: "",
            },
            ship_zip_code: {
                name: "ship_zip_code",
                rules: "trim|max_length[255]",
                max_len: "255",
                min_len: "",
                default_value: "",
            },
            ship_country_iso_3: {
                name: "ship_country_iso_3",
                rules: "trim|max_length[3]",
                max_len: "3",
                min_len: "",
                default_value: "",
            },
            ship_location_label: {
                name: "ship_location_label",
                rules: "trim|max_length[255]",
                max_len: "255",
                min_len: "",
                default_value: "",
            },
            ship_zip_code_ext: {
                name: "ship_zip_code_ext",
                rules: "trim|max_length[255]",
                max_len: "255",
                min_len: "",
                default_value: "",
            },
            shipping_address_id: {
                name: "shipping_address_id",
                rules: "trim|max_length[15]|integer",
                max_len: "15",
                min_len: "",
                default_value: "",
            },
            company_id: {
                name: "company_id",
                rules: "trim|max_length[15]|integer",
                max_len: "15",
                min_len: "",
                default_value: "",
            },
            fuel_surcharge: {
                name: "fuel_surcharge",
                rules: "trim|max_length[15]|integer",
                max_len: "15",
                min_len: "",
                default_value: "",
            },
            estimated_delivery_date: {
                name: "estimated_delivery_date",
                rules: "trim",
                max_len: "",
                min_len: "",
                default_value: "",
            },
        },
    },
};

// getters
const getters = {
    shipment_planners: (state) => {
        return state.shipment_planners;
    },
};

// actions
const actions = {
    async fetchShipmentPlanners({ rootState, commit, dispatch }, payload = null) {
        try {
            let body = payload.body ? payload.body : "";
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            const response = await getShipmentPlanners({ body: body, headers: config.headers });

            if (typeof response !== "undefined" && response.data) {
                if (response.data.page) {
                    commit("mutate", {
                        property: "page",
                        with: response.data.page,
                    });
                }

                if (body.options) {
                    commit("mutate", {
                        property: "shipment_planner_options",
                        with: response.data.shipment_planners,
                    });
                } else {
                    commit("mutate", {
                        property: "shipment_planners",
                        with: response.data.shipment_planners,
                    });
                }

                return response.data;
            } else {
                console.log("fetch all response error");
                return;
            }
        } catch (error) {
            console.log("fetch all error");
            return;
        }
    },
    async fetchShipmentPlanner({ rootState, commit, dispatch }, payload = null) {
        try {
            let response = null;
            let body = payload.body ? payload.body : "";
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await getShipmentPlanner({ body: body, headers: config.headers }, payload.id);

            if (typeof response !== "undefined" && response.data) {
                commit("mutate", {
                    property: "selectedShipmentPlanner",
                    with: response.data.shipment_planner,
                });
                return response.data;
            } else {
                console.log("fetch response error");
                return;
            }
        } catch (error) {
            console.log("fetch single error");
            return;
        }
    },
    async printShipmentPlanner({ rootState, commit, dispatch }, payload = null) {
        try {
            let response = null;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await printShipmentPlanner(payload.id);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("fetch print response error");
                return;
            }
        } catch (error) {
            console.log("print error");
            return;
        }
    },
    async saveShipmentPlanner({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            if (typeof body["shipment_id"] === "undefined" || body["shipment_id"] == null || body["shipment_id"] == "") {
                delete body["shipment_id"];
                response = await createShipmentPlanners({ body: body, headers: config.headers });
            } else {
                let shipment_id = body["shipment_id"];
                delete body["shipment_id"];
                response = await updateShipmentPlanners({ body: body, headers: config.headers }, shipment_id);
            }

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("save response error");
                return;
            }
        } catch (error) {
            console.log("save error");
            return;
        }
    },
    async deleteShipmentPlanner({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await deleteShipmentPlanners(payload.id);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("delete response error");
                return;
            }
        } catch (error) {
            console.log("delete error");
            return;
        }
    },
};

// mutations
const mutations = {
    mutate(state, payload) {
        state[payload.property] = payload.with;
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
